import axios from "axios";
import idAuthHeader from "../auth-header";
const API_URL = process.env.REACT_APP_API_URL + "api/upload-history";

class UploadHistoryService {
  async getHistory(applicationId) {
    return axios.get(API_URL, {
      params: {
        applicationId: applicationId,
      },
      headers: await idAuthHeader(),
    });
  }
}

const uploadHistoryService = new UploadHistoryService();
export default uploadHistoryService;
